module.exports = __webpack_public_path__ + "static/media/Retreats-03.d0049fe6.webp";